import ConfirmAlert from "./ConfirmAlert";

export default ConfirmAlert;
